let getPublicationsByYear = async ({
  url,
  community_id,
  year = 2020,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        communityById(id: "${community_id}") {
          name
          description
          items(
            first: ${itemsPerPage}
            page: ${currentPage}
            hasMetadata: {
              AND: [
                { column: METADATA_FIELD_ID, operator: EQ, value: 15 }
                { column: VALUE, operator: LIKE, value: "${year}%" }
              ]
            }
          ) {
            paginatorInfo {
              count
              currentPage
              hasMorePages
              total
              perPage
            }
            data {
              id
              handle
              thumbnail
              url
              metadata{
                id
                metadata_field_id
                element
                qualifier
                value
              }
            }
          }
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.communityById);
};

let getPublicationsByTwoConditions = async ({
  url,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        itemsDosCondiciones(
          hasMetadata: {
            AND: [
              {column:METADATA_FIELD_ID,operator:EQ,value:57}
              {column:VALUE,operator:EQ,value:"LAMAR"}
            ]     
        }
          hasMetadata1: {
          AND: [
            {column:METADATA_FIELD_ID,operator:EQ,value:7}
            {column:VALUE,operator:EQ,value:"Huancayo"}
          ]
          
        }
          , first: ${itemsPerPage}, page: ${currentPage}) {
          paginatorInfo{
              count
              total 
              currentPage
              hasMorePages
            }
            data{
              id
              handle
              metadata{
                metadata_field_id
                value
              }
              
            }
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.itemsDosCondiciones);
};

let getPublicationsByCollection = async ({
  url,
  collection_id,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        collectionById(id: "${collection_id}") {
          name
          facetIssuedYear
          items(
            first: ${itemsPerPage}
            page: ${currentPage}
            orderBy: [
              { column: ISSUED_DATE, order: DESC },
              { column: HANDLE, order: DESC }
            ]
          ) {
            paginatorInfo {
              count
              currentPage
              hasMorePages
              total
              perPage
            }
            data {
              id
              handle
              thumbnail
              url
              metadata {
                id
                metadata_field_id
                element
                qualifier
                value
              }
            }
          }
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.collectionById);
};

export {
  getPublicationsByYear,
  getPublicationsByCollection,
  getPublicationsByTwoConditions,
};
